import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { UserContext } from "./context/UserContext";
import FooterBn from "./FooterBn"; // Import the Footer component
import "./styles/Signup.css"; // Import the updated custom CSS

function Signup() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const navigate = useNavigate();

  const { user } = useContext(UserContext);

  useEffect(() => {
    if (user) {
      navigate("/"); // or navigate("/dashboard") if you have one
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Make the POST request to sign up
      const response = await axios.post(
        "https://server.goatteachers.com/api/auth/signup",
        { name, email, password },
      );

      console.log(response.data);
      alert("Signup successful! Please log in.");

      // Redirect to the login page after successful signup
      navigate("/login");
    } catch (error) {
      console.error("Error during signup:", error);
      setError(
        error.response ? error.response.data.message : "Error during signup",
      );
    }
  };

  return (
    <>
      <div className="signup-container">
        <div className="signup-form-wrapper">
          <h3 className="signup-title">Create Account</h3>

          {error && <p className="error-message">{error}</p>}

          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label htmlFor="name">Full Name</label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="input-group password-container">
              <label htmlFor="password">Password</label>
              <input
                type={showPassword ? "text" : "password"} // Toggle password visibility
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <i
                className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                onClick={() => setShowPassword(!showPassword)} // Toggle password visibility
                style={{ cursor: "pointer" }}
              />
            </div>

            <button type="submit" className="btn-signup">
              Sign Up
            </button>
          </form>

          <p className="signup-footer">
            I already have an account <a href="/login">Log in</a>
          </p>
        </div>
      </div>
      <FooterBn />
    </>
  );
}

export default Signup;
